export default __webpack_public_path__ + "static/media/clientFive.a6533111.png";